import api from "../../api"
import useNotification from "../Notification"
import { getSession } from "../../auth"
import { utils, writeFile } from 'xlsx';
import dayjs from 'dayjs'
import { translateStatus } from "./dashboard";

export const JOURNEY_COLUMN_PAGE_SIZE = 10
export const JOURNEY_LIST_PAGE_SIZE = 25

const getOpportunityValue = (card) => Number(card?.value || 0)

const getColumnTotalValue = (column) => Number(column?.total_value || 0)

const updateColumnSummary = (column, countDelta = 0, valueDelta = 0) => ({
    ...column,
    opportunity_count: Math.max(0, Number(column?.opportunity_count ?? column?.cards?.length ?? 0) + countDelta),
    total_value: Math.max(0, getColumnTotalValue(column) + valueDelta),
})

export const moveJourneyColumn = async (journeyId, columnId, destination, position, refreshBoard) => {
    if (!journeyId || !columnId || !destination) return

    const enterpriseId = getSession().profile.enterprise.id

    const response = await api.post(`api/enterprises/${enterpriseId}/journeys/move_column/`, {
        "column_id": columnId,
        "destination": destination,
        "position": position
    })
    
    if (response.status === 200)
        await refreshBoard(journeyId)
    else
        useNotification(
            "Ops!",
            "Algo deu errado ao tentar mover as oportunidades, tente novamente!",
            "danger"
        )
}

export const moveAllCards = async (journey, origin, destination, refreshBoard) => {
    if (!journey || !origin || !destination) return false

    const response = await api.post(
        `api/enterprises/${journey.enterprise}/journeys/${journey.id}/opportunities/move_all_cards/`,
        {
            "origin": origin,
            "destination": destination
        },
        {
            timeout: 120000
        }
    )

    if (response.status === 200) {
        await refreshBoard(journey.id)
        return true
    }

    useNotification(
        "Ops!",
        "Algo deu errado ao tentar mover as oportunidades, tente novamente!",
        "danger"
    )
    return false
}
export const moveCard = async (card, journey, lastPos, nextPos, callback, failback, failback2) => {
    const oldvalue = structuredClone(journey)

    callback(true)
    //setLoading(true)
    const res = await api.post(`api/enterprises/${journey.enterprise}/journeys/${journey.id}/opportunities/${card.id}/move/`, {
        'column': nextPos.toColumnId,
        'position': nextPos.toPosition
    })
    //setLoading(false)

     if (res.status === 400){
        if (res.data === "New Column not found"){
            useNotification("Ops!", "Coluna não encontrada!", "danger")
            callback(false, oldvalue)
            failback()
        }
        else if (res.data === 'Opportunity not found'){
            useNotification("Ops!", "Oportunidade não encontrada!", "danger")
            callback(false, oldvalue)
            failback2()
        }
        return
    }
    else if (res.status !== 200) {
        callback(false, oldvalue)
        useNotification(
            "Ops",
            "Algo deu errado, tente novamente.",
            "danger"
        )
    }
}

export const moveCardCallback = (commit, oldvalue, card, lastPos, nextPos, setBoard) => {
    if (commit)
        setBoard(prev => {
            const cardValue = card?.archived ? 0 : getOpportunityValue(card)
            const cardCount = card?.archived ? 0 : 1
            prev.columns.forEach(c => {
                if (c.id === lastPos.fromColumnId) {
                    c.cards.splice(lastPos.fromPosition, 1)
                    if (lastPos.fromColumnId !== nextPos.toColumnId) {
                        Object.assign(c, updateColumnSummary(c, -cardCount, -cardValue))
                    }
                }
                if (c.id === nextPos.toColumnId) {
                    let toPosition = nextPos.toPosition
                    if (toPosition === "last")
                        toPosition = c.cards.length
                    if (toPosition === "first")
                        toPosition = 0
                    c.cards.splice(toPosition, 0, card)
                    if (lastPos.fromColumnId !== nextPos.toColumnId) {
                        Object.assign(c, updateColumnSummary(c, cardCount, cardValue))
                    }
                }
            })
            return ({ ...prev, columns: prev.columns })
        })
    else {
        setBoard(oldvalue)
    }

}

export const newCard = async (journeyId, columnId, setBoard, setEdit, failback) => {
    if (journeyId && columnId) {
    setEdit({ card: { id: 0, column: columnId, title: ""}, column: Number(columnId || 0) })
    return 
    }

    if (journeyId && columnId) {
        const enterpriseId = getSession().profile.enterprise.id
        const response = await api.post(`api/enterprises/${enterpriseId}/journeys/${journeyId}/opportunities/`, {
            title: "",
            column: columnId,
            contact_id: null
        })
        if (response.status === 201) {
            setBoard(prev => {
                const foundBoard = prev?.columns.find(column => column.id === Number(columnId || 0))
                if (foundBoard) {
                    foundBoard.cards.push(response.data)
                    return { ...prev, columns: prev.columns }
                }
            })
            setEdit({ card: response.data, column: Number(columnId || 0) })
            return
        }
       else if (response.status === 404){
        useNotification("Ops!", "Coluna não encontrada!", "danger")
        failback()
        return
    }
        // TODO: useNotification for failures on opportunities creation
    }
}

const formatCustomFieldSnapshotValue = (field, value) => {
    if (field?.field_type === "select") {
        const option = (field.options || []).find(option => option.value === value)
        return option?.label || value
    }
    return value
}

export const buildCustomFieldsSnapshot = (custFieldValues, customFields) => {
    return Object.entries(custFieldValues || {}).reduce((acc, [key, value]) => {
        if (value === null || value === undefined) return acc

        const field = customFields.find(field => String(field.id) === String(key))
        if (!field) return acc

        acc[String(field.id)] = {
            name: field.name,
            type: field.field_type,
            value: formatCustomFieldSnapshotValue(field, value),
            show_in_summary: field.show_in_summary,
        }
        return acc
    }, {})
}

const saveCustomFields = async (custFieldValues, customFields, enterpriseId, journeyId, opportunityId, opportunityCreated = false) => {

    Object.keys(custFieldValues).forEach(key => {

        if (custFieldValues[key] === null || custFieldValues[key] === undefined ) { //||
            // (typeof custFieldValues[key] === 'string' && custFieldValues[key].trim
// () === '')) {
            delete custFieldValues[key]
        }
    });
    if (Object.keys(custFieldValues).length === 0) return

    const payload = Object.entries(custFieldValues).map(([key, value]) => {


        const field = customFields.find(f => {
            return f.id == key
        })
        if (field) {
            return {
                custom_field: field.id,
                value: value
            }
        }
        return null
    }).filter(item => item !== null)

    if (payload.length === 0) return
    const createdQuery = opportunityCreated ? '?created=true' : ''
    const response = await api.post(`api/enterprises/${enterpriseId}/journeys/${journeyId}/opportunities/${opportunityId}/custom_fields/${createdQuery}`, payload)
};

export const saveCard = async (journeyId, newState, thisColumn, setBoard, allUsers, allTags, allCustomFields, handleClose, setLoading, selectedEnterprise) => {
    if (journeyId) {
        if (setLoading) setLoading(true)
        const enterpriseId = getSession().profile.enterprise.id
        
        let contact_enterprise_id = null
        let contact_enterprise_name = null
        if (newState.contact_enterprise) {
            if (typeof newState.contact_enterprise === 'object' && newState.contact_enterprise?.id) {
                contact_enterprise_id = newState.contact_enterprise.id
                contact_enterprise_name = newState.contact_enterprise.name
            } else if (typeof newState.contact_enterprise === 'number' && !isNaN(newState.contact_enterprise)) {
                contact_enterprise_id = newState.contact_enterprise
                if (selectedEnterprise && selectedEnterprise.id === contact_enterprise_id) {
                    contact_enterprise_name = selectedEnterprise.name
                }
            }
        }
        
        const payload = {
            ...newState,
            contact_id: newState.contact?.id || null,
            contact_enterprise_id: contact_enterprise_id,
            value: newState.value || 0,
            history: []
        }
        
        let response = null
        if (newState.id)
            response = await api.patch(`api/enterprises/${enterpriseId}/journeys/${journeyId}/opportunities/${newState.id}/`, payload)
        else
            response = await api.post(`api/enterprises/${enterpriseId}/journeys/${journeyId}/opportunities/`, payload)
        if ([200, 201].includes(response?.status)) {
            newState.id = response.data.id
            const selectedColumn = response.data.column
            await saveCustomFields(newState.custom_fields, allCustomFields, enterpriseId, journeyId, newState.id, response.status === 201)
            setBoard((prevState) => {
                const selectedColumnId = Number(selectedColumn)
                const thisColumnId = Number(thisColumn)
                const newColumns = prevState.columns.map(column => {

                    if (selectedColumnId !== thisColumnId && column.id === thisColumnId){ // Remove from old column
                        const removedCard = column.cards.find(card => card.id === newState.id)
                        column.cards = column.cards.filter(card => card.id !== newState.id)
                        return updateColumnSummary(
                            column,
                            removedCard && !removedCard.archived ? -1 : 0,
                            removedCard?.archived ? 0 : -getOpportunityValue(removedCard)
                        )
                    }

                    if (column.id !== selectedColumnId) return column // Continue iteration
                    const oldCards = [...column.cards]

                    
                    if ((selectedColumnId !== thisColumnId || response.status === 201) && !oldCards.some(c => c.id === response.data.id)) //add card at the end if new or different column
                        oldCards.push(response.data)

                    const newCards = oldCards.map(card => {
                        if (card.id !== newState.id) return card

                        const updatedCard = { ...card }

                    Object.keys(newState).forEach(async key => {
                    if (key === "custom_fields") {
                        updatedCard.custom_fields = newState.custom_fields
                        updatedCard.custom_fields_snapshot = buildCustomFieldsSnapshot(newState.custom_fields, allCustomFields)
                        return
                    }
                    if (key in card) {
                        switch (key) {
                            case "contact":
                                updatedCard.contact = newState.contact?.name
                                break
                            case "contact_enterprise":
                                if (newState.contact_enterprise?.name) {
                                    updatedCard.contact_enterprise_name = newState.contact_enterprise.name
                                } else if (contact_enterprise_name) {
                                    updatedCard.contact_enterprise_name = contact_enterprise_name
                                } else if (typeof newState.contact_enterprise === 'string') {
                                    updatedCard.contact_enterprise_name = newState.contact_enterprise
                                }
                                break
                            case "owner":
                                const user = allUsers.find((user) => user.id === newState.owner)
                                if (user) {
                                    updatedCard.owner_id = newState.owner
                                    updatedCard.owner = `${user.first_name} ${user.last_name}`
                                    updatedCard.owner_name = updatedCard.owner
                                }
                                break
                            case "tags":
                                updatedCard.tags = newState.tags.map((tagId) => allTags.find((tag) => tag.id === tagId)).filter((tag) => tag !== undefined)
                                break
                            case "custom_fields":
                                updatedCard.custom_fields = newState.custom_fields
                                updatedCard.custom_fields_snapshot = buildCustomFieldsSnapshot(newState.custom_fields, allCustomFields)
                                break
                            default:
                                updatedCard[key] = newState[key]
                                break
                        }
                    }
                    })
                    return updatedCard
                })
                
                const createdHere = response.status === 201 && !column.cards.some(c => c.id === response.data.id)
                const movedIn = response.status === 200 && selectedColumnId !== thisColumnId
                const valueDelta = (!response.data?.archived && (createdHere || movedIn)) ? getOpportunityValue(response.data) : 0
                const countDelta = (!response.data?.archived && (createdHere || movedIn)) ? 1 : 0

                return updateColumnSummary({ ...column, cards: newCards }, countDelta, valueDelta)
                })
                return { ...prevState, columns: newColumns }
            })
            let message = 'Oportunidade atualizada com sucesso.'
            if (response.status === 201)
                message = 'Oportunidade criada com sucesso.'
            useNotification(
                "Sucesso!",
                message,
                "success"
            )
            if (setLoading) setLoading(false)
            return response
        } else if (response?.status === 400) {
            deleteCardCallback(thisColumn, newState.id, setBoard)
            const errorMessage = response?.data || "Oportunidade não encontrada"
            useNotification(
                "Ops",
                typeof errorMessage === 'string' ? errorMessage : "Erro ao salvar oportunidade",
                "danger"
            )
            handleClose()
            if (setLoading) setLoading(false)
            return response
        }
        
        const errorMsg = response?.data || "Algo deu errado, tente novamente."
        useNotification(
            "Ops",
            typeof errorMsg === 'string' ? errorMsg : "Erro ao salvar oportunidade",
            "danger"
        )
        if (setLoading) setLoading(false)
        return response
    }
}

export const deleteCardCallback = (thisColumn, cardId, setBoard) => {
    setBoard(prev => {
                const selectedColumn = prev.columns.find(column => column.id === thisColumn)
                const selectedCard = selectedColumn?.cards.find(card => card.id === cardId)
                if (selectedCard) {
                    selectedColumn.cards.splice(selectedColumn.cards.indexOf(selectedCard), 1)
                    Object.assign(
                        selectedColumn,
                        updateColumnSummary(selectedColumn, selectedCard.archived ? 0 : -1, selectedCard.archived ? 0 : -getOpportunityValue(selectedCard))
                    )
                }
                return { ...prev, columns: prev.columns }
            })
}

export const deleteCard = async (journeyId, newState, thisColumn, setBoard) => {
    const enterpriseId = getSession().profile.enterprise.id
    const response = await api.delete(`api/enterprises/${enterpriseId}/journeys/${journeyId}/opportunities/${newState.id}/`)
    if (response.status === 204) {
        deleteCardCallback(thisColumn, newState.id, setBoard)
        useNotification(
            "Sucesso!",
            "Oportunidade removida com sucesso.",
            "success"
        )
        return
    } else if (response.status === 400) {
        deleteCardCallback(thisColumn, newState.id, setBoard)
            useNotification(
        "Ops",
        "Oportunidade não encontrada",
        "danger"
    )
    return
    }
    useNotification(
        "Ops",
        "Algo deu errado, tente novamente.",
        "danger"
    )
}

export const archiveCard = async (journeyId, newState, thisColumn, setBoard) => {

    const enterpriseId = getSession().profile.enterprise.id
    const response = await api.patch(`api/enterprises/${enterpriseId}/journeys/${journeyId}/opportunities/${newState.id}/archive/`)
    if (response.status === 204) {
        setBoard(prev => {
            const selectedColumn = prev.columns.find(column => column.id === thisColumn)
            const selectedCard = selectedColumn?.cards.find(card => card.id === newState.id)
            if (selectedCard) {
                const wasArchived = selectedCard.archived
                selectedCard.archived = true
                Object.assign(
                    selectedColumn,
                    updateColumnSummary(selectedColumn, wasArchived ? 0 : -1, wasArchived ? 0 : -getOpportunityValue(selectedCard))
                )
            }
                // selectedColumn.cards.splice(selectedColumn.cards.indexOf(selectedCard), 1)
            return { ...prev, columns: prev.columns }
        })
        useNotification(
            "Sucesso!",
            "Oportunidade arquivada com sucesso.",
            "success"
        )
        return
    } else if (response.status === 400) {
        deleteCardCallback(thisColumn, newState.id, setBoard)
            useNotification(
        "Ops",
        "Oportunidade não encontrada",
        "danger"
    )
    return
    }
    useNotification(
        "Ops",
        "Algo deu errado, tente novamente.",
        "danger"
    )
}

export const unarchiveCard = async (journeyId, newState, thisColumn, setBoard) => {

    const enterpriseId = getSession().profile.enterprise.id
    const response = await api.patch(`api/enterprises/${enterpriseId}/journeys/${journeyId}/opportunities/${newState.id}/unarchive/`)
    if (response.status === 204) {
        setBoard(prev => {
            const selectedColumn = prev.columns.find(column => column.id === thisColumn)
            const selectedCard = selectedColumn?.cards.find(card => card.id === newState.id)
            if (selectedCard) {
                const wasArchived = selectedCard.archived
                selectedCard.archived = false
                Object.assign(
                    selectedColumn,
                    updateColumnSummary(selectedColumn, wasArchived ? 1 : 0, wasArchived ? getOpportunityValue(selectedCard) : 0)
                )
            }
            return { ...prev, columns: prev.columns }
        })
        useNotification(
            "Sucesso!",
            "Oportunidade desarquivada com sucesso.",
            "success"
        )
        return
    }
    useNotification(
        "Ops",
        "Algo deu errado, tente novamente.",
        "danger"
    )
}

export const loadKanban = async (journey, setLoading, setBoard, setEdit, close, options = {}) => {
    setLoading(true)
    const params = buildJourneyOpportunityParams({
        ...options,
        limit: undefined,
        offset: undefined,
    })
    params.set("cards_limit", JOURNEY_COLUMN_PAGE_SIZE)
    params.set("cards_offset", 0)
    const res = await api.get(`api/enterprises/${journey.enterprise}/journeys/${journey.id}/?${params.toString()}`, {timeout: 15000})
    setLoading(false)
    if (res.status === 200) {
        setBoard(res.data)
        // const urlParams = new URLSearchParams(window.location.search)
        // let opportunity = null
        // const column = res.data.columns.find(column => {
        //     const card = column.cards.find(card => card.id === Number(urlParams.get('selectedOpportunity')))
        //     if (card) {
        //         opportunity = card
        //         return card
        //     }
        // })
        // if (opportunity && column)
        //     setEdit({ card: opportunity, column: column })
        return
    }
    else if (res.status === 400){
        setLoading(false)
        useNotification("Ops!", "Jornada não encontrada!", "danger")
        close()
        return
    }
    useNotification(
        "Ops",
        "Algo deu errado, tente novamente.",
        "danger"
    )
}

export const loadColumnCards = async (journey, columnId, offset = 0, limit = JOURNEY_COLUMN_PAGE_SIZE, options = {}) => {
    if (!journey?.enterprise || !journey?.id || !columnId) return null

    try {
        const params = buildJourneyOpportunityParams({
            ...options,
            limit,
            offset,
            summary: true,
        })
        params.set("column", columnId)

        const res = await api.get(
            `api/enterprises/${journey.enterprise}/journeys/${journey.id}/opportunities/?${params.toString()}`,
            { timeout: 15000 }
        )

        if (res.status === 200) return res.data
    } catch (error) {
        return null
    }
    return null
}

export const buildJourneyOpportunityParams = (options = {}) => {
    const {
        limit,
        offset,
        summary = false,
        sortModel = [],
        search = "",
        sellers = [],
        tags = [],
        noTags = false,
        statuses = [],
        customFieldFilters = [],
    } = options

    const params = new URLSearchParams()

    if (limit !== undefined) params.set("limit", String(limit))
    if (offset !== undefined) params.set("offset", String(offset))
    if (summary) params.set("summary", "true")

    if (search) {
        params.set("title__contains", search)
    } else {
        params.set("archived", "false")
    }

    if (Array.isArray(sellers) && sellers.length > 0) {
        params.set("owner__in", sellers.join(","))
    }

    if (Array.isArray(tags) && tags.length > 0) {
        params.set("tags__in", tags.join(","))
    }

    if (noTags) {
        params.set("tags_empty", "true")
    }

    if (Array.isArray(statuses) && statuses.length > 0) {
        params.set("status__in", statuses.join(","))
    }

    if (Array.isArray(customFieldFilters) && customFieldFilters.length > 0) {
        params.set("custom_field_filters", JSON.stringify(customFieldFilters))
    }

    const sort = Array.isArray(sortModel) ? sortModel[0] : sortModel
    if (sort?.field && sort?.sort) {
        params.set("sort", `${sort.field}:${sort.sort}`)
    }

    return params
}

export const loadJourneyOpportunities = async (journey, options = {}) => {
    if (!journey?.enterprise || !journey?.id) return null

    const {
        limit = JOURNEY_LIST_PAGE_SIZE,
        offset = 0,
        sortModel = [],
        search = "",
        sellers = [],
        tags = [],
        noTags = false,
        statuses = [],
        customFieldFilters = [],
    } = options

    const params = buildJourneyOpportunityParams({
        limit,
        offset,
        summary: true,
        sortModel,
        search,
        sellers,
        tags,
        noTags,
        statuses,
        customFieldFilters,
    })

    try {
        const res = await api.get(
            `api/enterprises/${journey.enterprise}/journeys/${journey.id}/opportunities/?${params.toString()}`,
            { timeout: 15000 }
        )

        if (res.status === 200) return res.data
    } catch (error) {
        return null
    }
    return null
}

export const createColumn = async (journey, position, setLoading, callback) => {
    //setLoading(true)
    const res = await api.post(`api/enterprises/${journey.enterprise}/journeys/${journey.id}/columns/`,
        {
            'title': 'Nova coluna',
            'description': '',
            'position': position
        }
    )
    //setLoading(false)
    if (res.status === 201) {
        callback(res.data)
        return
    } else if (res.status === 404){
        setLoading(false)
        useNotification("Ops!", "Jornada não encontrada!", "danger")
        return
    }
    useNotification(
        "Ops",
        "Algo deu errado, tente novamente.",
        "danger"
    )

}

export const removeColumn = async (columnid, journey, setLoading, callback) => {
    //setLoading(true)
    const res = await api.delete(`api/enterprises/${journey.enterprise}/journeys/${journey.id}/columns/${columnid}/`)
    //setLoading(false)
    if (res.status === 204) {
        callback(res.data)
        return
    } else if (res.status === 400){
        useNotification("Ops!", "Coluna não encontrada!", "danger")
        callback(res.data)
        return
    }
    useNotification(
        "Ops",
        "Algo deu errado, tente novamente.",
        "danger"
    )

}

export const removeColumnCallback = (column_id, setBoard) => {
    setBoard(prev => ({ ...prev, columns: prev.columns.filter(column => column.id !== Number(column_id)) }))
}

export const changeColumnName = async (newname, columnId, journey, setLoading, callback, failback) => {
    //setLoading(true)
    const res = await api.patch(`api/enterprises/${journey.enterprise}/journeys/${journey.id}/columns/${columnId}/`,
        {
            'title': newname
        }
    )
    //setLoading(false)
    if (res.status === 200) {
        callback(res.data)
        return
    } else if (res.status === 400){
        useNotification("Ops!", "Coluna não encontrada!", "danger")
        failback()
        return
    }
    useNotification(
        "Ops",
        "Algo deu errado, tente novamente.",
        "danger"
    )
}

export const changeColumnNameCallback = async (data, setBoard) => {
    setBoard(prev => {
        const column = prev.columns.find(column => column.id === data.id)
        column.title = data.title
        return { ...prev, columns: prev.columns }
    })
}

export const changeColumnDescription = async (description, columnId, journey, setLoading, callback, failback) => {
    //setLoading(true)
    const res = await api.patch(`api/enterprises/${journey.enterprise}/journeys/${journey.id}/columns/${columnId}/`,
        {
            'description': description
        }
    )
    //setLoading(false)
    if (res.status === 200) {
        callback(res.data)
        return
    } else if (res.status === 400){
        useNotification("Ops!", "Coluna não encontrada!", "danger")
        failback()
        return
    }
    useNotification(
        "Ops",
        "Algo deu errado, tente novamente.",
        "danger"
    )
}

export const changeColumnDescriptionCallback = async (data, setBoard) => {
    setBoard(prev => {
        const column = prev.columns.find(column => column.id === data.id)
        column.description = data.description
        return { ...prev, columns: prev.columns }
    })
}

export const moveColumn = async (journey, column, nextPos, callback, failback) => {

    const oldvalue = structuredClone(journey)
    callback(true)
    //setLoading(true)
    const res = await api.post(`api/enterprises/${journey.enterprise}/journeys/${journey.id}/columns/${column.id}/move/`, {
        'position': nextPos.toPosition
    })
    //setLoading(false)

    if (res.status === 400){
        useNotification("Ops!", "Coluna não encontrada!", "danger")
        callback(false, oldvalue)
        failback()
        return
    }  else if (res.status !== 200) {
        callback(false, oldvalue)
        useNotification(
            "Ops",
            "Algo deu errado, tente novamente.",
            "danger"
        )
    }
}

export const moveColumnCallback = (commit, oldvalue, column, nextPos, setBoard) => {
    if (commit)
        setBoard(prev => {
            const columns = prev.columns.filter(c => c.id !== column.id)
            columns.splice(nextPos.toPosition, 0, column)
            return { ...prev, columns: columns }
        })
    else
        setBoard(oldvalue)
}

export const formatCurrency = (value, currency) => {
    let number = 0
    if (value) {
        const numeric = typeof (value) === 'number' ? value : Number(String(value).replace(/\D/g, ''))
        number = Number(numeric || 0) / 100
    } 
    return number.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })
}

export const formatCurrencyValue = (value) => {
    const number = Number(value || 0)
    return number.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })
}

export const removeComment = async (journey, commentId, callback) => {

    const res = await api.delete(`api/enterprises/${journey.enterprise}/journeys/${journey.id}/opportunities/deletecomment/${commentId}/`)
    if (res.status === 204) {
        callback()
    }
}

export const editComment = async (journey, commentId, value, callback) => {

    const res = await api.patch(`api/enterprises/${journey.enterprise}/journeys/${journey.id}/opportunities/editcomment/${commentId}/`, {text: value})
    if (res.status === 200) {
        callback()
    }
}

const treatNumber = (number) => {
    if (number)
        return parseInt(number*100) || 0
    return 0
}

export const calcBoardSummary = (board, id) => {
    if (!board?.columns) return
    const column = board.columns.find(column => column.id === id)
    if (column) {
        const loadedCards = column.cards || []
        const opportunityCount = Number(column.opportunity_count ?? loadedCards.length)
        const totalValue = column.total_value !== undefined && column.total_value !== null
            ? Number(column.total_value) * 100
            : loadedCards.filter((c) => !c.archived).reduce((a, b) => a + treatNumber(b.value), 0)

        return `${opportunityCount} oportunidades - R$ ${formatCurrency(totalValue)}`
    }
}


const aggregateString = (type, result, rowkey, row) => {
    return (type !== 'count' ? { [type]: Number((result[rowkey]?.[type] || 0) + (row?.[type] || 0)) } : {})
}

export const aggregateData = (type = ['count'], data, key, secKey) => {
    const result = {}

    data.forEach((row) => {

        const rowkey = String(row[key]) + (secKey ? ('_' + String(row[secKey])) : '')
        const aggregation = typeof (type) === 'string' ? aggregateString(type, result, rowkey, row) : type.map(t => ([t, aggregateString(t, result, rowkey, row)]))
        result[rowkey] = { ...(result[rowkey] || row), count: (result[rowkey]?.count || 0) + 1, ...aggregation }
    })

    return Object.values(result)
}

const translator = {
    opportunities: 'Oportunidades',
    communications: 'Comunicações',
    created_at: 'Criado em',
    title: 'Título',
    position: 'Posição',
    description: 'Descrição',
    value: 'Valor',
    currency: 'Moeda',
    contact_name: 'Nome do contato',
    secondary_contacts: 'Contatos secundários',
    estimated_at: 'Estimado em',
    closed_at: 'Fechado em',
    journey_name: 'Nome da jornada',
    column_name: 'Nome da coluna',
    owner_name: 'Nome do vendedor',
    duration: 'Duração',
    date: 'Data',
    time: 'Tempo',
    leg: 'Ramificação',
    origin: 'Origem',
    extension: 'Extensão',
    queue_name: 'Nome da Fila',
    agent: 'Vendedor',
    destination: 'Destino',
    messages: 'Mensagens',
    phone: 'Telefone',
    reasons: 'Motivos',
    dst_num: 'Número de destino',
    customer_code: 'Código do contato',
    tags: 'Marcações/tags',
    rating: 'Nota',
    issues: 'Problemas',
    rating_comment: 'Comentário',
    platform_entrypoint: 'Plataforma',
    queue_duration: 'Duração fila',
    bot_duration: 'Duração bot',
    wait_duration: 'Tempo de espera',
    survey_duration: 'Duração pesquisa de satisfação',
    total_msg: 'Total de mensagens',
    total_msg_general: 'Total de mensagens geral',
    average_response_time: 'Tempo médio de resposta',
    has_transfer: 'Tem transferência',
    classification: 'Classificação',
    agent_name: 'Nome do vendedor'
}

const discard_columns = new Set([
    'custom_field1_title'
    , 'custom_field1_value'
    , 'custom_field2_title'
    , 'custom_field2_value'
    , 'custom_field3_title'
    , 'custom_field3_value'
    , 'content_hash',
    , 'cortex_externalid'
    , 'cortex_kb'
    , 'cortex_duration'
    , 'cortex_question_amount'
    , 'cortex_answer_amount'
    , 'cortex_valid_answers'
])

const row_formatter = (key, value) => {
    if (key === 'status') {
        return translateStatus[value]
    }
    return value
}

export const generateExport = (data, format='xlsx') => {

    const workbook = utils.book_new()
    const csv_array = []

    Object.entries(data).map(([key, value]) => {

        const format_value = value.map(row => {
            return Object.fromEntries(Object.entries(row).flatMap(([k, v]) => {
                if (discard_columns.has(k)) return []
                if (! Object.keys(translator).includes(k)) return []
                return [[translator[k] || k, row_formatter(k, v)]]
            }))
        })

        const worksheet = utils.json_to_sheet(format_value);
        if (format === 'csv')
            csv_array.push([translator[key], utils.sheet_to_csv(worksheet)])
        else
            utils.book_append_sheet(workbook, worksheet, translator[key])
    })

    if (format === 'csv'){
        csv_array.forEach(([key, row]) => {
            // Create a Blob and trigger download
            const bom = "\uFEFF";
            const blob = new Blob([bom + row], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.href = url;
            const filename = `kwik_${key}_${dayjs().format("DD-MM-YYYY_HH-mm-ss").toString()}`
            link.setAttribute("download", `${filename}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
    }
    else{
    const filename = `kwik_${dayjs().format("DD-MM-YYYY_HH-mm-ss").toString()}.xlsx`
    writeFile(workbook, filename, { compression: true });
}


}


const COLORS = [
    "#1F77B4", "#FF7F0E", "#2CA02C", "#D62728", "#9467BD",
    "#8C564B", "#E377C2", "#7F7F7F", "#BCBD22", "#17BECF",
    "#AEC7E8", "#FFBB78", "#98DF8A", "#FF9896", "#C5B0D5",
    "#C49C94", "#F7B6D2", "#C7C7C7", "#DBDB8D", "#9EDAE5",
    "#393b79", "#5254a3", "#6b6ecf", "#9c9ede", "#637939",
    "#8ca252", "#b5cf6b", "#cedb9c", "#8c6d31", "#bd9e39",
    "#e7ba52", "#e7cb94", "#843c39", "#ad494a", "#d6616b",
    "#e7969c", "#7b4173", "#a55194", "#ce6dbd", "#de9ed6",
    "#3182bd", "#6baed6", "#9ecae1", "#c6dbef", "#31a354",
    "#74c476", "#a1d99b", "#c7e9c0", "#756bb1", "#9e9ac8"
];

export const BOUND_COLORS = {

}

export const applyBoundColors = (users) => {
    users.map(user => {
        if (String(user) in BOUND_COLORS) return
        BOUND_COLORS[String(user)] = COLORS.shift()
    })
}

export const markdownTranslator = {
  star: {
    label: 'Ponto',
    icon: <>*</>,
    add: '\n* '
  },

  bold: {
    label: 'Negrito',
    icon: <strong>B</strong>,
    add: '**texto**'
  },

  italic: {
    label: 'Itálico',
    icon: <em>I</em>,
    add: '*texto*'
  },

  strike: {
    label: 'Tachado',
    icon: <s>S</s>,
    add: '~~texto~~'
  },

  heading1: {
    label: 'Título 1',
    icon: <span style={{fontWeight: 'bold'}}>H1</span>,
    add: '\n# '
  },

  heading2: {
    label: 'Título 2',
    icon: <span style={{fontWeight: 'bold'}}>H2</span>,
    add: '\n## '
  },

  heading3: {
    label: 'Título 3',
    icon: <span style={{fontWeight: 'bold'}}>H3</span>,
    add: '\n### '
  },

  quote: {
    label: 'Citação',
    icon: <>“”</>,
    add: '\n> '
  },

//   codeInline: {
//     label: 'Código Inline',
//     icon: <span>{'<> '}</span>,
//     add: '`código`'
//   },

  codeBlock: {
    label: 'Bloco de Código',
    icon: <span>{'</>'}</span>,
    add: '\n```js\n\n```'
  },

  orderedList: {
    label: 'Lista Numerada',
    icon: <>1.</>,
    add: '\n1. '
  },

//   unorderedList: {
//     label: 'Lista com Traço',
//     icon: <>-</>,
//     add: '\n- '
//   },

  checkbox: {
    label: 'Checklist',
    icon: <>☑</>,
    add: '\n- [ ] '
  },

  link: {
    label: 'Link',
    icon: <>🔗</>,
    add: '[texto](url)'
  },

  image: {
    label: 'Imagem',
    icon: <>🖼️</>,
    add: '![alt](url)'
  },

  table: {
    label: 'Tabela',
    icon: <>▦</>,
    add: '\n| Coluna 1 | Coluna 2 |\n| --- | --- |\n| Valor 1 | Valor 2 |'
  },

  hr: {
    label: 'Linha Horizontal',
    icon: <>―</>,
    add: '\n---\n'
  },

//   highlight: {
//     label: 'Destaque',
//     icon: <>✨</>,
//     add: '==texto=='
//   },

//   emoji: {
//     label: 'Emoji',
//     icon: <>😊</>,
//     add: '😊'
//   },

//   blockInfo: {
//     label: 'Bloco Informativo',
//     icon: <>ℹ️</>,
//     add: '\n> **Info:** '
//   },

//   blockWarning: {
//     label: 'Bloco de Aviso',
//     icon: <>⚠️</>,
//     add: '\n> **Aviso:** '
//   },

//   blockSuccess: {
//     label: 'Bloco de Sucesso',
//     icon: <>✔️</>,
//     add: '\n> **Sucesso:** '
//   },

//   mathInline: {
//     label: 'Math Inline',
//     icon: <>∑</>,
//     add: '$equação$'
//   },

//   mathBlock: {
//     label: 'Math Block',
//     icon: <>∫</>,
//     add: '\n$$\n equação \n$$'
//   }
}
